module.exports = __webpack_public_path__ + "img/male.3d74ae27.png";